/**
 * Turkish strings.
 *
 * Technical terms stay in English per src/i18n/glossary.js, with Turkish
 * suffixes attached by apostrophe. Article tags, category names, tool names and
 * code are never translated.
 */

export const tr = {
  nav: {
    about: "Hakkımda",
    experience: "Deneyim",
    projects: "Projeler",
    articles: "Yazılar",
    contact: "İletişim",
    aiResources: "AI Kaynakları",
    changelog: "Changelog",
    testimonials: "Referanslar",
    personalSpace: "Kişisel Alan",
    openMenu: "Menüyü aç",
    closeMenu: "Menüyü kapat",
  },

  common: {
    backToHome: "Ana sayfaya dön",
    backToArticles: "Yazılara dön",
    allAiResources: "Tüm AI kaynakları",
    viewAll: "Tümünü gör",
    readMore: "Devamını oku",
    loading: "Yükleniyor",
    minRead: "{{count}} dakikalık okuma",
    notFound: "Bulunamadı",
    clearFilter: "Filtreyi temizle",
    all: "Tümü",
    groups: "grup",
    tools: "araç",
    otherCategories: "Diğer kategoriler",
  },

  hero: {
    greeting: "Merhaba, ben Alper Kırmızı",
    headline: "Apple ekosisteminin tamamında sıra dışı deneyimler tasarlıyorum.",
    bio: "Apple platformlarında güvenli ve yüksek performanslı yazılım geliştiren Senior Software Engineer. Paycell'de güvenilir fintech deneyimleri kurmaya odaklanıyorum.",
    ctaRecommendations: "Referansları oku",
    ctaAiResources: "AI Kaynakları",
    linkedin: "LinkedIn",
    medium: "Medium",
  },

  articles: {
    label: "Yazılar",
    sectionTitle: "Yazılar ve düşünceler",
    pageTitle: "Yazılar ve düşünceler",
    pageIntro:
      "iOS geliştirme, mimari kararlar ve ölçekli fintech uygulamaları kurarken öğrendiklerim üzerine uzun yazılar.",
    viewAll: "Tüm yazıları gör",
    count: "{{count}} yazı",
    countIn: "{{tag}} etiketinde {{count}} yazı",
    none: "Bu etikette yazı bulunamadı.",
    englishOnly: "Bu yazı İngilizce",
    englishOnlyHint: "Gövde metni henüz Türkçeye çevrilmedi.",
    turkishOnly: "Bu yazı Türkçe",
    turkishOnlyHint: "Gövde metni henüz İngilizceye çevrilmedi.",
    searchPlaceholder: "Yazılarda ara",
    startHere: "Buradan başlayın",
    related: "İlgili yazılar",
    onThisPage: "Bu sayfada",
  },

  ai: {
    label: "AI Kaynakları",
    pageTitle: "Gerçekten kullandığım araçlar",
    pageIntro:
      "Var olan her şeyin listesi değil. Bunlar regüle bir kod tabanıyla, bir release takvimiyle ve sınırlı bir sabırla temas ettikten sonra ayakta kalan araçlar; yanlarında da her birinin gerçekte neyi iyi yaptığı.",
    summary: "{{categories}} kategori · {{tools}} araç",
    categorySummary: "{{groups}} grup · {{tools}} araç",
    whatItIs: "Nedir",
    howIUseIt: "Nasıl kullanıyorum",
    whyItEarns: "Neden yerini hak ediyor",
    moreIn: "{{group}} grubundaki diğerleri",
    officialSite: "Resmî site",
    categoryNotFound: "Kategori bulunamadı",
    categoryNotFoundBody: "Böyle bir kategori yok.",
    toolNotFound: "Araç bulunamadı",
    toolNotFoundBody: "Böyle bir kayıt yok.",
    status: {
      daily: "Her gün",
      weekly: "Haftalık",
      occasional: "Ara sıra",
      evaluating: "Deniyorum",
    },
  },

  testimonials: {
    label: "Referanslar",
    sectionTitle: "Birlikte çalıştıklarım ne diyor",
    intro:
      "Paycell'deki 6 yılı aşkın sürede ve mobil geliştirmedeki on yılda, fintech alanında yetenekli ekiplerle çalışma ayrıcalığına sahip oldum.",
    leaveOne: "Birlikte çalıştık mı? Bir referans bırakın.",
    viewAll: "Tüm referansları gör",
    empty: "Henüz referans yok.",
    beFirst: "İlk referansı siz bırakın!",
  },

  contact: {
    label: "İletişim",
    sectionTitle: "Tanışalım",
    intro:
      "Danışmanlık, iş birliği, mentorluk ya da etkinlik daveti olsun, anlamlı sohbetlere her zaman açığım.",
    leaveMessage: "Mesaj bırak",
    linkedinDescription: "Profesyonel ağ",
    githubDescription: "Açık kaynak ve kod",
    emailDescription: "Bana ulaşın",
  },

  forms: {
    name: "Ad Soyad",
    email: "E-posta",
    subject: "Konu",
    message: "Mesaj",
    role: "Görev ve Şirket",
    send: "Gönder",
    sending: "Gönderiliyor…",
    sent: "Gönderildi",
    cancel: "Vazgeç",
    required: "Bu alan zorunlu",
    invalidEmail: "Geçerli bir e-posta adresi girin",
    genericError: "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
    successMessage: "Teşekkürler. Size döneceğim.",
  },

  about: {
    label: "Hakkımda",
    title: "Apple ekosistemini",
    titleLine2: "inşa etmek",
    yearsTitle: "Apple platformlarında 6+ yıl",
    yearsSubtitle: "iOS, macOS ve watchOS geliştirme",
    yearsBody:
      "Sadece kod yazmıyorum; uçtan uca ürün tasarlıyorum. Yüksek ölçekli kurumsal sistemlerin zorlu mühendislik gereksinimleriyle, Apple ekosisteminin tamamında piksel hassasiyetinde arayüz ve pürüzsüz kullanıcı deneyimi tutkusunu birlikte yürütüyorum.",
    yearsCurrent:
      "Şu sıralar: Kişisel yan projelerde dopamin odaklı verimlilik mekaniklerini deniyorum ve AI çağında mobil mimari üzerine yazıyorum.",
    domainTitle: "Alan uzmanlığı",
    domainBody:
      "Yoğun regülasyonlu ve yüksek ölçekli ortamlarda çalışıyorum. Karmaşık ödeme akışlarını kurgulamaktan digital lending ve hisse senedi işlem modülleri geliştirmeye kadar, güvenlik ve performans pazarlık konusu değil.",
    stackTitle: "Ekosistem ve mühendislik",
    architectureTitle: "Mimari ve liderlik",
    architectureBody:
      "Ölçeklenen sistemler ve iyi çalışan ekipler kuruyorum. Yüksek baskılı ortamlarda sakin ve olumlu enerjiyi korumakla tanınırım; cesur teknik kararlarda inisiyatif almaktan çekinmem. Ekip arkadaşlarıma mentorluk yapar, fonksiyonlar arası ekipleri hem moral hem mühendislik standardı yüksek kalacak şekilde yönlendiririm.",
    remoteTitle: "Uzaktan çalışma disiplini",
    remoteBody:
      "Son 5 yıldır tamamen uzaktan çalışıyorum. Günlük derin çalışmam Edirne'deki masamda V60 demlemeyle geçse de, ekip arkadaşlarımla sık sık yüz yüze buluşuyorum. Gerçek uzaktan çalışma disiplininin, titiz asenkron iletişimle içten ve keyifli insan bağını birlikte gerektirdiğine inanıyorum.",
  },

  experience: {
    label: "Deneyim",
    title: "Nerede çalışıyorum",
    role: "Senior iOS Developer",
    period: "2020 — Bugün",
    summary:
      "63.000 aday arasından, 8 ay süren zorlu bir 'Top Talent' programıyla seçildim ve bugün bu büyük ölçekli kurumsal fintech platformunun mobil geliştirmesini yönetiyorum. Hem teknik lider hem Scrum Master olarak, cesur mimari kararları, App Store release döngülerini ve ekip hızını yönetirken teknik işin içinde kalmayı sürdürüyorum.",
    domainsLabel: "Öne çıkan projeler ve alanlar",
    ndaNote:
      "Proje detayları NDA kapsamında gizlidir. İş; ödeme işleme, dijital cüzdan çözümleri ve kurumsal ölçekte finansal hizmetleri kapsıyor.",
    contributionsLabel: "Öne çıkan katkılar",
  },

  projects: {
    label: "Projeler",
    sectionTitle: "Yaptığım işler",
    pageTitle: "Yaptığım işler",
    pageIntro:
      "Tasarımını, geliştirmesini ve yayınını tek başıma yaptığım ürünler: bir macOS pano aracı, utandırmaya iyi tepki vermeyen insanlar için bir odak zamanlayıcısı ve bir öğretmen için kurulmuş bir kurs uygulaması.",
    viewAll: "Tüm projeleri gör",
    none: "Bu platformda proje yok.",
    notFound: "Proje bulunamadı",
    notFoundBody: "Böyle bir proje yok.",
    allProjects: "Tüm projeler",
    nextProject: "Sonraki proje",
    role: "Rol",
    timeline: "Süre",
    stack: "Teknolojiler",
    visitSite: "Siteyi ziyaret et",
    noWriteup: "Bu projenin yazısı henüz yayımlanmadı.",
    liveOnSite: "Bu sitede canlı",
    tryLiveTitle: "Hemen burada deneyin",
    tryLiveBody: "Bu proje bu sitenin içinde çalışıyor. Açın ve bir seviyeyi baştan sona deneyin.",
    openApp: "Uygulamayı aç",
  },

  footer: {
    builtWith: "React ve FastAPI ile geliştirildi",
    rights: "© 2026 Alper Kırmızı. Tüm hakları saklıdır.",
  },
};
